export default __webpack_public_path__ + "static/media/headline_bg.28ad2195.svg";